import lottie from 'lottie-web/build/player/lottie';

var animationData = {
  v: '5.7.1',
  fr: 29.9700012207031,
  ip: 0,
  op: 112.000004561854,
  w: 200,
  h: 810,
  nm: 'Comp 3',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: 'Null 2',
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [63.982, 404.743, 0], ix: 2 },
        a: { a: 0, k: [50, 50, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 120.0000048877,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Path 451',
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 1,
              s: [15],
            },
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 39,
              s: [-27],
            },
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 56.12,
              s: [15],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 90,
              s: [-27],
            },
            { t: 111.000004521123, s: [15] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 1,
              s: [69.778, 87.533, 0],
              to: [-3.333, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.833, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 39,
              s: [49.778, 87.533, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 56,
              s: [69.778, 87.533, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.833, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 90,
              s: [49.778, 87.533, 0],
              to: [0, 0, 0],
              ti: [-3.333, 0, 0],
            },
            { t: 111.000004521123, s: [69.778, 87.533, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [13.111, 31.234, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 1,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 39,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 56,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 90,
              s: [150, 150, 100],
            },
            { t: 111.000004521123, s: [150, 150, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-1.726, -1.726],
                    [-1.157, -0.318],
                    [0, 0],
                    [-1.192, 2.065],
                    [-0.219, 1.781],
                    [0.838, 0.103],
                    [0.12, -0.979],
                    [0, 0],
                    [-0.216, 1.76],
                    [0.858, 0.105],
                    [0.129, -1.049],
                    [0, 0],
                    [-0.226, 1.835],
                    [1.062, 0.222],
                    [0.15, -1.226],
                    [0, 0],
                    [0, 0],
                    [2.84, 0.349],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.617, -1.239],
                    [0, 0],
                  ],
                  o: [
                    [0.323, 0.322],
                    [1.558, 0],
                    [0, 0],
                    [1.194, -2.065],
                    [0.219, -1.781],
                    [-0.838, -0.103],
                    [-0.121, 0.979],
                    [0, 0],
                    [0.216, -1.76],
                    [-0.858, -0.105],
                    [-0.129, 1.049],
                    [0, 0],
                    [0.226, -1.834],
                    [-1.061, -0.222],
                    [-0.15, 1.226],
                    [0, 0],
                    [0, 0],
                    [-2.84, -0.349],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.616, 1.239],
                    [0, 0],
                  ],
                  v: [
                    [5.074, 28.188],
                    [7.569, 29.72],
                    [20.622, 31.234],
                    [23.304, 29.053],
                    [26.194, 15.467],
                    [24.461, 12.867],
                    [22.163, 14.972],
                    [21.966, 16.57],
                    [22.402, 13.028],
                    [20.554, 10.319],
                    [18.092, 12.085],
                    [17.607, 16.035],
                    [18.235, 10.924],
                    [16.546, 8.106],
                    [13.99, 10.035],
                    [13.318, 15.508],
                    [14.748, 3.854],
                    [12.603, 0.024],
                    [9.492, 3.209],
                    [6.967, 18.993],
                    [4.001, 16.553],
                    [0.882, 15.861],
                    [0.364, 19.804],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0.949019607843, 0.925490196078, 0.898039215686, 1],
                ix: 3,
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Path 451',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 120.0000048877,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Rectangle 1917 :M',
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 1,
              s: [76.255, 12.467, 0],
              to: [-6.667, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.833, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 39,
              s: [36.255, 12.467, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 56.12,
              s: [76.255, 12.467, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.833, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 90,
              s: [36.255, 12.467, 0],
              to: [0, 0, 0],
              ti: [-6.667, 0, 0],
            },
            { t: 111.000004521123, s: [76.255, 12.467, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [63.849, 251.346, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 1,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 23,
              s: [170, 170, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 39,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 56.12,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 76,
              s: [170, 170, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 90,
              s: [150, 150, 100],
            },
            { t: 111.000004521123, s: [150, 150, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [4.732, 0.641], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1917',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [50.9, 252.792], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: -135, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 1911917',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [4.732, 0.642], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1865',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [50.9, 249.9], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 495, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 1861865',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [28.868, 0.642], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1882',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [64.263, 251.405], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 180, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 1881882',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 120.0000048877,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Rectangle 2399',
      sr: 1,
      ks: {
        o: { a: 0, k: 50, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-30.536, 405.941, 0], ix: 2 },
        a: { a: 0, k: [-65, 0, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
              t: 1,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
              t: 39.12,
              s: [130, 150, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.181, 0.181, 0.181], y: [0.15, -2.995, 0] },
              t: 56.12,
              s: [150, 150, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
              t: 90.12,
              s: [130, 150, 100],
            },
            { t: 111.000004521123, s: [150, 150, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: { a: 0, k: [130, 541], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: 'Rectangle Path 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false,
            },
            {
              ty: 'op',
              nm: 'Offset Paths 1',
              a: { a: 0, k: -0.5, ix: 1 },
              lj: 1,
              ml: { a: 0, k: 4, ix: 3 },
              ix: 3,
              mn: 'ADBE Vector Filter - Offset',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 2399 Stroke',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: { a: 0, k: [130, 541], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: 'Rectangle Path 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.729411764706, 0.592156862745, 0.439215686275, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Rectangle 2399 Fill',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 120.0000048877,
      st: 0,
      bm: 0,
    },
  ],
  markers: [{ tm: 0, cm: '0', dr: 0 }],
};

const inspirationIcons = document.querySelectorAll('.inspiration-icon');
Array.from(inspirationIcons).forEach((inspirationIcon) => {
  var params = {
    container: inspirationIcon,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  var anim = lottie.loadAnimation(params);
});

// Old version: Only show when visible
// if (typeof window.IntersectionObserver !== 'undefined') {
//   const inspirationIcons = document.querySelectorAll(".inspiration-icon");
//   Array.from(inspirationIcons).forEach((inspirationIcon) => {
//     var params = {
//       container: inspirationIcon,
//       renderer: "svg",
//       loop: false,
//       autoplay: false,
//       animationData: animationData,
//     };

//     var anim = lottie.loadAnimation(params);

//     function handleIntersection(entries) {
//       entries.map((entry) => {
//         if (entry.isIntersecting) {
//           anim.play();
//           observer.unobserve(entry.target);
//         }
//       });
//     }

//     let observer = new IntersectionObserver(handleIntersection, {
//       threshold: 0.75,
//     });
//     observer.observe(inspirationIcon)
//   });
// } else {
//   const inspirationIcons = document.querySelectorAll(".inspiration-icon");
//   Array.from(inspirationIcons).forEach((inspirationIcon) => {
//     inspirationIcon.style.display = 'false';
//   });
// }
